import {Component, ConnectedComponent} from 'lowkey-component'
import Swiper, {Mousewheel, Navigation} from 'swiper'

import {MediaQuery} from '@services/MediaQuery'
import {ScrollService} from '@services/ScrollService'
import {createVoiceState} from '@services/VoiceState'
import {WindowService} from '@services/WindowService'
import {appSelectors} from '@store/appSlice'
import {voiceSelectors} from '@store/voiceSlice'

type Ref = {
  swiper: Component<HTMLDivElement> | undefined;
  next: Component<HTMLDivElement> | undefined;
  prev: Component<HTMLDivElement> | undefined;
  close: Component<HTMLDivElement> | undefined;
  backdrop: Component<HTMLDivElement> | undefined;
};

export class VoicesDialog extends ConnectedComponent<HTMLDivElement, Ref> {
  private swiper: Swiper | null = null;
  private mq = MediaQuery.create();
  private slides: HTMLDivElement[] = [];
  private voiceState = createVoiceState();
  private scroll = ScrollService.create();
  private windowService = WindowService.create();

  constructor(element: HTMLDivElement) {
    super(element);
    this.refs = {
      swiper: undefined,
      next: undefined,
      prev: undefined,
      close: undefined,
      backdrop: undefined,
    };
  }

  renderNext() {
    const nextNav = this.element.querySelector(
      '.o-voices-dialog_right_card',
    ) as HTMLImageElement;
    const nextNavImg = nextNav.querySelector('img') as HTMLImageElement;
    const nextNavName = nextNav.querySelector(
      '.a-voice-name_name span',
    ) as HTMLImageElement;

    const {realIndex = 0} = this.swiper || {};
    realIndex - 1 < 0 ? this.slides.length - 1 : realIndex - 1;
    const nextIndex =
      realIndex + 1 > this.slides.length - 1 ? 0 : realIndex + 1;

    const nextImg = this.slides[nextIndex].querySelector(
      '.a-image_img',
    ) as HTMLImageElement;

    const nextName = this.slides[nextIndex].querySelector(
      '.a-voice-name_name span',
    ) as HTMLSpanElement;

    nextNavImg?.setAttribute('src', nextImg?.getAttribute('src') || '');
    nextNavName.textContent = nextName.textContent;
  }

  renderPrev() {
    const prevNav = this.element.querySelector(
      '.o-voices-dialog_left_card',
    ) as HTMLImageElement;
    const prevNavImg = prevNav.querySelector('img') as HTMLImageElement;
    const prevNavName = prevNav.querySelector(
      '.a-voice-name_name span',
    ) as HTMLImageElement;

    const {realIndex = 0} = this.swiper || {};
    // console.log(this.swiper.realIndex)
    // const prevIndex =
    realIndex - 1 < 0 ? this.slides.length - 1 : realIndex - 1;
    realIndex + 1 > this.slides.length - 1 ? 0 : realIndex + 1;
    const prevIndex =
      realIndex - 1 < 0 ? this.slides.length - 1 : realIndex - 1;

    // const {name: prevName} = this.slides[prevIndex].dataset;
    const prevImg = this.slides[prevIndex].querySelector(
      '.a-image_img',
    ) as HTMLImageElement;

    const prevName = this.slides[prevIndex].querySelector(
      '.a-voice-name_name span',
    ) as HTMLSpanElement;

    // prevLabel.textContent = prevName;
    prevNavImg?.setAttribute('src', prevImg?.getAttribute('src') || '');
    prevNavName.textContent = prevName.textContent;
  }

  render() {
    this.renderPrev();
    this.renderNext();
  }

  didMount() {
    if (!this.refs.swiper?.element) {
      return;
    }
    this.windowService.onResize.connect(this.onResizeWindow);
    this.observe(appSelectors.selectOrientation, this.onChangeOrientation);

    this.slides = Array.from(this.element.querySelectorAll('.swiper-slide'));

    this.observe(voiceSelectors.selectIsOpenVoiceModal, (isOpen) => {
      !isOpen && this.hide();
    });

    this.observe(voiceSelectors.selectCurrenVoiceModalIndex, (index) => {
      this.show(index);
    });

    this.swiper = new Swiper(this.refs.swiper.element, {
      modules: [Navigation, Mousewheel],
      slidesPerView: 'auto',
      direction: 'horizontal',
      centeredSlides: true,
      allowTouchMove: true,
      spaceBetween: this.mq.isDesktop() ? 0 : 27,
      preventInteractionOnTransition: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: this.refs.next?.element,
        prevEl: this.refs.prev?.element,
      },
      on: {
        slideChange: () => {
          this.render();
        },
        init: () => {
          this.render();
        },
      },
    });

    this.refs.close?.on('click', () => {
      this.hide();
    });

    this.refs.backdrop?.on('click', () => {
      this.hide();
    });

    this.resize();
  }

  onChangeOrientation = () => {
    if (this.mq.isPhone()) {
      this.resize();
    }
  };

  resize = () => {
    const height = window.innerHeight;
    this.element.style.height = `${height}px`;
    this.slides.map((slide) => {
      const item = slide.querySelector<HTMLDivElement>('.o-voice-dialog-item');
      if (item) {
        item.style.height = `${height}px`;
      }
    });
  };

  onResizeWindow = () => {
    if (this.mq.isDesktop()) {
      this.resize();
    }
  };

  didUnmount() {
    this.windowService.onResize.disconnect(this.onResizeWindow);
    this.swiper?.destroy();
  }

  show(index: number) {
    const top = this.scroll.stopScroll(document.body);
    this.element.style.top = `${top}px`;
    this.swiper?.slideTo(index, 0);

    this.resize();
    this.element.classList.add('show');
  }

  hide() {
    this.element.style.top = `${0}px`;
    this.scroll.startScroll();
    this.voiceState.updateCurrentVoiceModalIndex(-1);
    this.voiceState.updateIsOpenVoiceModal(false);
    this.element.classList.remove('show');
  }
}
